import { AppState } from "store";
import { UsersFiltersArgs } from "./types";

export const usersFiltersSelector = ({
  filters,
}: AppState): UsersFiltersArgs => {
  return filters.users;
};
